<script setup lang="ts">
import {
  ProgrammesCard,
  ActivitiesCard,
  ResourcesCard,
  UpcomingInterviewCard,
  NotificationsCard,
  SettingsCard,
  ThemeSettingsCard,
  } from '@/components/dashboard';
import { useStudentStore } from '@/stores/student';

const studentStore = useStudentStore();
</script>

<template>
  <VContainer fluid>
    <VRow>
      <VCol cols="12" sm="6" md="3" lg="2">
        <NotificationsCard />
      </VCol>
      <VCol cols="12" sm="6" md="3" lg="2">
        <UpcomingInterviewCard />
      </VCol>
      <VCol cols="12" sm="6" lg="4">
        <ThemeSettingsCard location="dashboard" />
      </VCol>
    </VRow>
    <VRow>
      <VCol cols="6" lg="4">
        <ProgrammesCard />
      </VCol>
      <VCol cols="6" lg="4">
        <ActivitiesCard />
      </VCol>
    </VRow>
    <VRow>
      <VCol cols="6" lg="4">
        <ResourcesCard />
      </VCol>
      <VCol cols="6" lg="4">
        <SettingsCard />
      </VCol>
    </VRow>
  </VContainer>
</template>

<style lang="scss">
@use '@/styles/pages/_dashboard.scss';
</style>

<route lang="yaml">
name: dashboard
alias: '/dashboard'
meta:
  requiresAuth: true
  title: page_titles.dashboard
</route>
